import stateClass from '../baseState';

const GROUP_CHANGE_EVENT = 'activeGroupsChange';

class classesStateClass extends stateClass{

    constructor(props){
        super(props);

        this.activeClasses = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

        this.data = {
            groups: [
                {id: '10_12', name: '10 - 12', classes: [10, 11, 12]},
                {id: '7_12', name: '7 - 12', classes: [7, 8, 9, 10, 11, 12]},
                {id: '7_9', name: '7 - 9', classes: [7, 8, 9]},
                {id: '1_6', name: '1 - 6', classes: [1, 2, 3, 4, 5, 6]},
                {id: 'all', name: 'Visas grupas', classes: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]}
            ],
            classes: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
            ]
        }
    }
    getAllClasses() {

        return this.data.classes;
    }
    setActiveGroupByID(id) {

        if(this.getActiveGroup().id === id) {
            this.activeClasses = [];

        } else {
            this.activeClasses = this.getGroupByID(id).classes.slice();
        }
        

        this.emit(GROUP_CHANGE_EVENT);
    }

    getGroupByID(id) {

        for (var i = this.data.groups.length - 1; i >= 0; i--) {
            if(this.data.groups[i].id === id) {

                return this.data.groups[i];
            }
        }
    }

    setActiveGroups(classes) {


        this.activeClasses = classes.slice();

        this.emit(GROUP_CHANGE_EVENT);
    }

    getActiveClassesFields(){

        var activeFields = [];
        for (var i = this.activeClasses.length - 1; i >= 0; i--) {

            activeFields.push(this.activeClasses[i] + 'kl');
        }

        return activeFields;
    }

    getActiveGroup() {

        for (var i = this.data.groups.length - 1; i >= 0; i--) {
            var group = this.data.groups[i];

            if(this.activeClasses.length !== group.classes.length) {
                continue;
            }
            var pass = true;
            for (var n = this.activeClasses.length - 1; n >= 0; n--) {
                if(group.classes.indexOf(this.activeClasses[n]) === -1) {
                    pass = false;
                }
            }

            if(pass){
                return group;
            }
        }

        return false;
    }

    getActiveClasses(){

        return this.activeClasses;
    }
}

var classesState = new classesStateClass();

export {classesState, GROUP_CHANGE_EVENT};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/filters/classesState.js